import script from "./UserAccountDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAccountDetails.vue?vue&type=script&setup=true&lang=ts"

import "@/components/user/UserAccountDetails.css?vue&type=style&index=0&id=0a7c241d&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7c241d"]])

export default __exports__